import { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

// Mirrors a Query render-prop `loading` flag into parent state so the parent
// can disable controls that live outside the Query. Layout effects, so the
// disabled state is committed before paint, in the same commit as the Query's
// loading=true. Resets the flag when the Query unmounts.
const QueryLoadingSync = ({ loading, onChange }) => {
  useLayoutEffect(() => {
    onChange(loading);
  }, [loading, onChange]);

  useLayoutEffect(() => () => onChange(false), [onChange]);

  return null;
};

QueryLoadingSync.propTypes = {
  loading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default QueryLoadingSync;
